import { Get, FileUpload, Post } from "@/utils";
import { ApiPath } from "@/enums";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    //TODO: Missing endpoint
    confirmcompleteprofile() {
      const userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}common/confirmcompleteprofile?userId=${userid}`
        )
        .then(res => {
          return res;
        })
        .catch(res => {
          const errors = res.response.data;
          throw errors;
        });
    },
    async getImage({ }, query) {
      const { data: image } = await Get(
        `${ApiPath.Common}/presignedgeturl`,
        query
      );
      return image;
    },
    async uploadImage({ }, { file, ...query }) {
      const { data: url } = await Get(
        `${ApiPath.Common}/presignedupdateurl`,
        query
      );

      if (url) {
        const { data: uploadResult } = await FileUpload(url, file, {
          headers: {
            "Content-Type": ""
          }
        });

        return uploadResult;
      }

      return null;
    },
    async uploadDocument({ }, { file, ...query }) {
      const { data: url } = await Get(
        `${ApiPath.Common}/presigneddocumentupdateurl`,
        query
      );

      if (url) {
        const { data: uploadResult } = await FileUpload(url, file, {
          headers: {
            "Content-Type": ""
          }
        });

        return uploadResult;
      }

      return null;
    },
    async uploadDocumentWithReturnUrl(context, query) {
      return new Promise((resolve, reject) => {
        context
          .dispatch("uploadDocument", query)
          .then(() => {
            context
              .dispatch("getImage", query)
              .then(res => resolve(res))
              .catch(err => reject(err));
          })
          .catch(err => reject(err));
      });
    },
    async getDocumentUrls({ }, { bucketType, objectIds }) {
      const { data: result } = await Post(
        `${ApiPath.Common}/presignedgeturls?bucketType=${bucketType}`,
        objectIds
      );
      return result;
    },
    async getBucketPresignedUrls({ }, body) {
      const { data: imageUrls } = await Post(
        `${ApiPath.Common}/getbucketpresignedurls`,
        body
      );
      return imageUrls;
    },
    async getUSPostcodes({ }, postcode) {
      const { data: postcodes } = await Get(
        `${ApiPath.Common}/getuspostcodes?postcode=${postcode}`
      );
      return postcodes;
    },
    async getUKPostcodes({ }, postcode) {
      const { data: postcodes } = await Get(
        `${ApiPath.Common}/getukpostcodes?postcode=${postcode}`
      );
      return postcodes;
    },
    async validateUserZipCode({ }, postcode) {
      const { data: isValidUS } = await Get(
        `${ApiPath.Common}/getuspostcodes?postcode=${postcode}`
      );

      if (isValidUS.postcodes[0] == null) {
        const { data: isValidUK } = await Get(
          `${ApiPath.Common}/getukpostcodes?postcode=${postcode}`
        );
        return isValidUK;
      } else {
        return isValidUS;
      }
    },
    async getCountries({ }) {
      const { data: postcodes } = await Get(`${ApiPath.Common}/getcountries`);
      return postcodes;
    },
    async removeprofileimage({ }, query) {
      const { data: removed } = await Post(
        `${ApiPath.Common}/removeimage`,
        null,
        { params: query }
      );
      return removed;
    },
    async removefile({ }, query) {
      const { data: removed } = await Post(
        `${ApiPath.Common}/removeimage`,
        null,
        { params: query }
      );
      return removed;
    },
  }
};
